// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
  dirty: true,
  raw: 'v0.0.21-3044-gcbe0de4f19-dirty',
  hash: 'gcbe0de4f19',
  distance: 3044,
  tag: 'v0.0.21',
  semver: {
    options: {
      loose: false,
      includePrerelease: false,
    },
    loose: false,
    raw: 'v0.0.21',
    major: 0,
    minor: 0,
    patch: 21,
    prerelease: [],
    build: [],
    version: '0.0.21',
  },
  suffix: '3044-gcbe0de4f19-dirty',
  semverString: '0.0.21+3044.gcbe0de4f19',
  version: '2024.0.1',
};
/* tslint:enable */
